import { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import MainPagetitle from '../../../layouts/MainPagetitle';
import HaveAnIssue from '../MyComplaints/HaveAnIssue';
import MyComplaintsModal from '../MyComplaints/MyComplaintsModal';
import MyComplaintsOverview from '../MyComplaints/MyComplaintsOverview';
import MyComplaintsSearch from '../MyComplaints/MyComplaintsSearch';

const RaiseComplaints = (props) => {
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
  });
  const [complaints, setComplaints] = useState([]);
  const [complaintsOverview, setComplaintsOverview] = useState([]);
  const complaintsOverviewCards = ['total', 'assigned', 'inProgress', 'resolved', 'closed'];
  const [rowcount, setRowcount] = useState(0);
  const [isFetching, setIsFetching] = useState(true);
  const columns = [
    {
      dataIndex: 'complaintId',
      title: 'Complaint ID',
      render: (text, record) => {
        return (
          <>
            <div>
              <h6 className="text-primary fw-bold">{text || '-'}</h6>
            </div>
          </>
        );
      },
    },
    {
      dataIndex: 'customerName',
      title: 'Customer Name',
    },
    {
      dataIndex: 'loanAccountNumber',
      title: 'LAN',
    },
    {
      dataIndex: 'queryType',
      title: 'Query Type',
      render: (text) => { return text?.toTitleCase() || '-' },
    },
    {
      dataIndex: 'isExistingCustomer',
      title: 'Customer Type',
      render: (text, record) => {
        return record?.isExistingCustomer ? 'Existing' : 'New';
      },
    },
    {
      dataIndex: 'source',
      title: 'Source',
      render: (text) => { return text?.toTitleCase() || '-' },
    },
    {
      dataIndex: 'assignedComplianceOfficer',
      title: 'Assign To',
      render: (text, record) => {
        return record?.assignedComplianceOfficer?.name?.toTitleCase() || '-';
      },
    },
    {
      dataIndex: 'createdAt',
      title: 'Raised On',
      render: (text, record) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        if (record?.createdAt) {
          return date;
        } else {
          return '-';
        }
      },
    },
    {
      dataIndex: 'status',
      title: 'Application Status',
      render: (text, record) => {
        let mappedStatus = _enum.STATUS_COLOR_MAP[record?.status?.toLowerCase()] || '';
        return (
          <Dropdown className="status-dropdown no-arrow pe-none">
            <Dropdown.Toggle as="div" className={mappedStatus}>
              <span>{record?.status?.toTitleCase()}</span>
              <i className="fa-solid fa-chevron-down ms-2"></i>
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
  ];

  const onPageChange = (pageData) => {
    setSearch({
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 10,
    });
  };

  const onSearch = (data, reset) => {
    let defaultSearchData = Object.only(data, ['limit', 'page']);
    let payload;
    if (reset) {
      payload = {
        ...defaultSearchData,
      };
      getComplaints(payload, reset);
    } else {
      payload = {
        ...data,
        page: 1,
        limit: 10,
      };
      getComplaints(payload, reset);
    }
    setSearch(payload);
  };

  const getComplaintsOverview = () => {
    props.apis.apiGetComplaintCards().then((res) => {
      setComplaintsOverview(res);
    });
  };

  const getComplaints = (params = {}, reset) => {
    let payload = {};
    if (reset) {
      let defaultSearchData = Object.only(search, ['page', 'limit']);

      setSearch(defaultSearchData);
      payload = {
        ...defaultSearchData,
        ...params,
      };
    } else {
      payload = {
        ...search,
        ...params,
      };
    }
    props.apis.apiGetAllComplaints(payload).then(({ data, total }) => {
      setComplaints(data);
      setRowcount(total);
      setIsFetching(false);
    });
  };
  //   ---------------------------------------------------------
  const [complaintsAttachmentsData, setComplaintsAttachmentsData] = useState([]);
  const [attachmentsFields, setAttachmentsFields] = useState([{ attachments: '' }]);
  const [attachmentsInputData, setAttachmentsInputData] = useState([
    {
      label: 'Attach Supporting Document (PDF / Images)',
      name: 'attachments',
      type: 'file',
    },
  ]);
  const [errorMessage, setErrorMessage] = useState({ name: '', message: '' });
  const [modalFields, setModalFields] = useState([
    {
      label: '1. Customer Information',
      name: 'customerInfoTitle',
      type: 'textarea',
      customcolspan: 12,
      outerclass: 'form-title',
    },
    {
      label: '',
      name: 'skiprow1',
      type: 'textarea',
      customcolspan: 12,
      outerclass: 'form-title',
    },
    {
      name: 'customerName',
      label: 'Customer Name',
      type: 'text',
      placeholder: 'Customer Name',
      required: true,
    },
    {
      name: 'mobileNumber',
      label: 'Mobile No.',
      type: 'text',
      placeholder: 'Mobile No.',
      onChange: (value) => handleMobileNo(value),
      required: true,
    },
    {
      label: 'Email ID',
      name: 'emailId',
      type: 'email',
      placeholder: 'Please Enter',
      onChange: (value) => handleEmailId(value),
    },
    {
      name: 'loanAccountNumber',
      label: 'Enter Loan Account Number (LAN)',
      type: 'text',
      placeholder: 'Enter Loan Account Number (LAN)',
      required: true,
    },
    {
      name: 'isExistingCustomer',
      label: 'Is Customer Existing?',
      type: 'checkbox',
      outerclass: 'd-flex flex-row-reverse align-item-center',
    },
    //
    // 2. Complaint Details
    {
      label: '2. Complaint Details',
      name: 'complaintDetailsTitle',
      type: 'textarea',
      customcolspan: 12,
      outerclass: 'form-title mt-3',
    },
    {
      label: '',
      name: 'skiprow2',
      type: 'textarea',
      customcolspan: 12,
      outerclass: 'form-title',
    },
    {
      label: '',
      name: 'skiprow3',
      type: 'textarea',
      customcolspan: 12,
      outerclass: 'form-title',
    },
    {
      name: 'source',
      label: 'Source',
      type: 'select',
      options: _enum.COMPLAINT_SOURCE,
      placeholder: 'Select Source',
      required: true,
    },
    {
      name: 'queryType',
      label: 'Query Type',
      type: 'select',
      options: _enum.COMPLAINT_QUERY_TYPE,
      placeholder: 'Select Query Type',
      required: true,
    },
    //
    {
      name: 'categoryOfService',
      label: 'Category Of Service',
      type: 'select',
      options: _enum.CATEGORY_OF_SERVICE_LIST,
      placeholder: 'Category Of Service',
      required: true,
      customcolspan: '12',
    },
    {
      name: 'complaintTitle',
      label: 'Complaint Title',
      type: 'text',
      placeholder: 'Complaint Title',
      required: true,
      customcolspan: '12',
    },
    {
      name: 'complaintExplanation',
      label: 'Complaint Explanation',
      type: 'text',
      placeholder: 'Complaint Explanation',
      required: true,
      customcolspan: '12',
    },
  ]);

  const handleMobileNo = (e) => {
    const numberReg = _enum?.REGEX?.number;
    const fieldValue = e.target.value;
    if (numberReg.test(fieldValue) && fieldValue.length === 10) setErrorMessage('');
    else
      setErrorMessage({
        name: 'mobileNumber',
        message: 'Please enter a valid Mobile Number',
      });
  };

  const handleEmailId = (e) => {
    const emailReg = _enum?.REGEX?.email;
    const fieldValue = e.target.value;
    if (emailReg.test(fieldValue)) setErrorMessage('');
    else
      setErrorMessage({
        name: 'emailAddress',
        message: 'Please enter a valid Email Address',
      });
  };

  const [editData, setEditData] = useState([]);
  const [editmode, setEditmode] = useState(false);
  const [viewmode, setViewmode] = useState(false);
  const [openCanvas, setOpenCanvas] = useState(false);
  const [popupfields, setPopupfields] = useState({});
  const [popupdata, setPopupdata] = useState({});

  const openModal = () => {
    setOpenCanvas(true);
  };

  const closeModal = () => {
    setOpenCanvas(false);
  };

  const addModalFields = (values) => {
    let fields = (modalFields || []).reduce((o, n) => ({ ...o, [n.name]: n }), {});
    let formdata = Object.map(fields, (v, k) => '');
    setPopupfields(fields);
    setPopupdata(formdata);
    setOpenCanvas(true);
  };

  const onModalClose = () => {
    closeModal();
    setPopupfields({});
    setViewmode(false);
    setEditmode(false);
    setEditData({});
  };

  const handleSubmit = (e, data, form) => {
    e.preventDefault();
    let parsedData = parseInput(data || {});

    let attachments = [];
    if (Array.isArray(parsedData?.dynamicfield)) {
      attachments = parsedData.dynamicfield
        .map((item) => item?.attachments)
        .filter((att) => att && typeof att === 'string' && att.trim() !== '');
    } else if (Array.isArray(parsedData?.attachments)) {
      attachments = parsedData.attachments.filter(
        (att) => att && typeof att === 'string' && att.trim() !== ''
      );
    } else if (
      typeof parsedData?.attachments === 'string' &&
      parsedData.attachments.trim() !== ''
    ) {
      attachments = [parsedData.attachments];
    }

    let payload = {
      // 1. Customer Information
      customerName: parsedData?.customerName?.toString(),
      mobileNumber: parsedData?.mobileNumber?.toString(),
      emailId: parsedData?.emailId?.toString(),
      loanAccountNumber: parsedData?.loanAccountNumber?.toString(),
      isExistingCustomer: parsedData.isExistingCustomer,

      // 2. Complaint Details
      source: (parsedData?.source).toString(),
      queryType: (parsedData?.queryType).toString(),
      categoryOfService: (parsedData?.categoryOfService || '').toString(),
      complaintTitle: (parsedData?.complaintTitle || '').toString(),
      complaintExplanation: (parsedData?.complaintExplanation || '').toString(),
      attachments: attachments,
    };
    console.log('payload: ', payload);

    props.apis.apiCreateComplaint(payload).then((res) => {
      swal2.fire({
        title: 'Complaint added successfully.',
        icon: 'success',
        iconColor: '#FF4D4D',
        timer: 4000,
      });
      closeModal();
      getComplaints();
    });
  };

  // ROW SELECTION
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [notSelected, setNotSelected] = useState(true);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleBulkAssign = () => {
    let payload = {
      complaintIds: [...selectedRowKeys],
    };

    if (selectedRowKeys.length === 0) {
      swal2.fire({
        title: 'Please select any complaint',
        icon: 'info',
        iconColor: '#FF4D4D',
      });
    } else {
      props.apis.apiComplaintAssignBulk(payload).then((res) => {
        if (res) {
          swal2.fire({
            title: 'Complaint Assigned',
            text: 'Complaint assigned successfully !!',
            icon: 'success',
            iconColor: '#FF4D4D',
            timer: 4000,
          });
          setSelectedRowKeys([]);
          getComplaints();
        }
      });
    }
  };

  useEffect(() => {
    if (selectedRowKeys.length > 0) {
      setNotSelected(false);
    } else {
      setNotSelected(true);
    }
  }, [selectedRowKeys]);

  useEffect(() => {
    getComplaints();
    getComplaintsOverview();
  }, [search]);

  return (
    <>
      <MainPagetitle
        mainTitle="Raise Complaints"
        pageTitle={'Raise Complaints'}
        parentTitle={'Home'}
        pageIcon={imagepaths.complaintsIconActive}
      />

      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col-xl-6 col-lg-6 col-md-12 mb-3 mb-lg-0">
            <HaveAnIssue
              title="Raise Complaint on Behalf of Customer"
              description="Create a new complaint for your customers & assign it to the appropriate officer."
              onRaiseComplaint={() => addModalFields()}
            />
          </div>
          <div className="col-xl-6 col-lg-6 col-md-12">
            <MyComplaintsOverview title="My Complaints Overview" cards={complaintsOverviewCards} data={complaintsOverview} />
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="tbl-caption-container">
                  <h4 className="heading mb-0">Recently Raised Complaints</h4>
                  <div className="d-flex flex-wrap">
                    <div className="d-flex align-items-center">
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => handleBulkAssign()}
                        disabled={notSelected}
                      >
                        Assign to Compliance Officer
                      </button>
                    </div>
                    <MyComplaintsSearch onSearch={(...arg) => onSearch(...arg)} />
                  </div>
                </div>
                <AppTable
                  data={complaints}
                  total={rowcount}
                  onChange={(...arg) => onPageChange(...arg)}
                  columns={columns}
                  reorder={true}
                  viewable={false}
                  editable={false}
                  deletable={false}
                  checkbox={true}
                  rowSelection={rowSelection}
                  loading={isFetching}
                  isCustomRowKey={true}
                  customRowKey={'complaintId'}
                ></AppTable>
              </div>
            </div>
          </div>
        </div>
      </div>

      <MyComplaintsModal
        id="raiseComplaintsCanvas"
        title={`${editmode ? 'Edit Complaint' : viewmode ? 'View Complaint' : 'Raise Complaint'}`}
        show={openCanvas}
        onClose={() => onModalClose()}
        data={popupdata}
        editdata={editData}
        fields={popupfields}
        editmode={editmode}
        onSubmit={(...args) => handleSubmit(...args)}
        submitText={`${editmode ? 'Update' : 'Submit'}`}
        disableallfields={viewmode ? true : false}
        hasDynamicFields={true}
        dynamicfields={attachmentsFields}
        dynamicfieldid="attachments"
        dynamicdefaultdata={complaintsAttachmentsData}
        dynamicinputs={attachmentsInputData}
        dynamicinputsColClass="col-12 col-md-12 col-lg-8"
        errorMessage={errorMessage}
      />
    </>
  );
};

export default constore(RaiseComplaints);
